import React from 'react';

type MainPageContextType = {
  isHandheld: boolean;
};

export const MainPageContext = React.createContext<MainPageContextType>({
  isHandheld: false,
});
